<template>
  <div class="service-features">
    <service-header :signedIn="signedInUser !== null"/>
    <section class="features">
      <h2>
        <div>必要な機能だけを</div>
        <span class="text-service">誰でも簡単に使えます</span>
      </h2>
      <div class="features-inner">
        <div class="img-wrapper">
          <img :src="require('@/assets/images/service/feature_chat.png')" alt="チャット機能"/>
        </div>
        <div class="description-wrapper">
          <h3>
            グループチャット、ダイレクトメッセージ
          </h3>
          <p>
            <span class="d-block">トークルームを作成しその中のメンバー間で、リアルタイムでスピーディなやり取りができます。</span>
            <span class="d-block">メンションすれば伝えたい情報を相手にスムーズに届けることができ、様々な絵文字でリアクションができるので細かな感情が伝えやすくなっています。写真を添付して情報共有したり、編集機能を使えば後からでも文章を直すことができるので安心です。</span>
            <span class="d-block">みんなに見られたくない1対1のコミュニケーションは、ダイレクトメッセージを使うことで秘密が守られます。</span>
          </p>
        </div>
      </div>
      <div class="features-inner">
        <div class="img-wrapper">
          <img :src="require('@/assets/images/service/feature_meeting.png')" alt="会議機能"/>
        </div>
        <div class="description-wrapper">
          <h3>
            WEB会議、カフェ
          </h3>
          <p>
            <span class="d-block">最大24名同時接続可能なWEB会議や、雑談する感覚で気軽に誘えるカフェなど、特別なアプリがなくてもSharewind一つで行うことができます。</span>
            <span class="d-block">リアルタイムで書き込めるホワイトボード機能が搭載されており、より現実の会議に近いスタイルでコミュニケーションを取ることが可能です。</span>
            <span class="d-block">あらかじめスケジュールが決まっている場合は、日時を設定し人数に合わせて「会議室」を予約しておくことができます。</span>
          </p>
        </div>
      </div>
      <div class="features-inner">
        <div class="img-wrapper">
          <img :src="require('@/assets/images/service/feature_project.png')" alt="プロジェクト機能"/>
        </div>
        <div class="description-wrapper">
          <h3>
            プロジェクト、タスク管理
          </h3>
          <p>
            <span class="d-block">プロジェクトはタスクの「カード」を作成して管理。カードに期日と担当者を設定し「検討中」「進行中」といったステータスに分類すれば、プロジェクト全体の進捗をひと目で把握できます。もちろん、その中から「自分に関係するタスク」だけを抽出して確認する事も可能です。</span>
            <span class="d-block">プロジェクトメンバーは簡単にファイル共有が出来たり、チャットと連携すればシームレスな情報共有も可能です。</span>
          </p>
        </div>
      </div>
    </section>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'

export default {
  name: 'ServiceFeatures',
  components: {
    ServiceHeader,
    ServiceFooter
  },
  computed: {
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-features {

  .features {
    background-color: white;
    padding: 80px 20px 100px 20px;

    @include mq(md) {
      padding: 130px 20px 100px 20px;
    }

    h2 {
      text-align: center;
      font-size: 32px;
      font-weight: 600;
      line-height: 1.3;
      margin-bottom: 60px;
    }

    &-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1100px;
      margin: 0 auto 60px auto;

      @include mq(md) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;

        &:nth-child(even) {
          flex-direction: row;
        }
      }

      .description-wrapper {
        width: 100%;

        @include mq(md) {
          width: 48%;
        }

        h3 {
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 40px;

          @include mq(md) {
            text-align: left;
          }

          span {
            display: block;
            font-size: 13px;
            margin-top: 10px;
          }
        }

        p {
          font-size: 15px;
          line-height: 1.6;
        }

        .text-service {
          font-weight: 600;
        }
      }

      .img-wrapper {
        width: 100%;
        margin-bottom: 30px;

        @include mq(md) {
          width: 48%;
          margin-bottom: 0;
        }

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
